export default "/images/white-down.svg?b5af80dbbcc4c49b49938e9c847b6932";